var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGold(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_722_32628)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 18C13.9706 18 18 13.9706 18 9C18 4.02944 13.9706 0 9 0C4.02944 0 0 4.02944 0 9C0 13.9706 4.02944 18 9 18Z",
    fill: "#F1B32B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.85938 2.25C5.20875 2.25 2.25 5.20875 2.25 8.85938C2.25 12.51 5.20875 15.4688 8.85938 15.4688C12.51 15.4688 15.4688 12.51 15.4688 8.85938C15.4688 7.10646 14.7724 5.42534 13.5329 4.18584C12.2934 2.94634 10.6123 2.25 8.85938 2.25ZM8.85938 13.8206C7.54357 13.8206 6.28166 13.2979 5.35124 12.3675C4.42083 11.4371 3.89812 10.1752 3.89812 8.85938C3.89812 7.54357 4.42083 6.28166 5.35124 5.35124C6.28166 4.42083 7.54357 3.89812 8.85938 3.89812C10.1752 3.89812 11.4371 4.42083 12.3675 5.35124C13.2979 6.28166 13.8206 7.54357 13.8206 8.85938C13.8206 10.1752 13.2979 11.4371 12.3675 12.3675C11.4371 13.2979 10.1752 13.8206 8.85938 13.8206ZM7.21125 8.865L8.865 11.34L10.5075 8.865L8.865 6.38438L7.21125 8.865Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_722_32628"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGold);
export default __webpack_public_path__ + "static/media/gold.ee1a44059bd2f80d1ce94346253d2878.svg";
export { ForwardRef as ReactComponent };